import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureDataFactoryLinkedService } from 'app/model/linkedservice/azure-data-factory.linkedservice';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from './azure-key-vault.util';
import { restAuthTypes } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataFactoryLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                subscriptionId: '*',
                resourceGroupName: '*',
                dataFactoryName: '*',
                username: '*',
                userTenant: '*',
                password: 'secret',
                authenticationType: '*'
            },
            parameters: '*'
        }
    }
})

export class AzureDataFactoryLinkedServiceAdapter extends LinkedServiceAdapter<AzureDataFactoryLinkedService> {

    protected modelConstructor(): new () => AzureDataFactoryLinkedService {
        return AzureDataFactoryLinkedService;
    }

    protected model(): IModel {
        return AzureDataFactoryLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: AzureDataFactoryLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.AzureDataFactoryLinkedService;
        properties.type = Metamodel.modelFor(AzureDataFactoryLinkedService).name;
        properties.typeProperties = {
            subscriptionId: this.valueToResource(linkedService, AzureDataFactoryLinkedService.SUBSCRIPTION_ID),
            resourceGroupName: this.valueToResource(linkedService, AzureDataFactoryLinkedService.RESOURCE_GROUP_NAME),
            dataFactoryName: this.valueToResource(linkedService, AzureDataFactoryLinkedService.DATA_FACTORY_NAME),
        };
        if (linkedService.servicePrincipalId) {
            properties.typeProperties.servicePrincipalId = linkedService.servicePrincipalId;
            properties.typeProperties.servicePrincipalKey = passwordOrAKVtoSecretBase(linkedService.servicePrincipalKey, this.context);
            properties.typeProperties.tenant = linkedService.tenant;
            properties.typeProperties.authenticationType = restAuthTypes.AadServicePrincipal;
        } else {
            properties.typeProperties.authenticationType = restAuthTypes.ManagedServiceIdentity;
        }
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: AzureDataFactoryLinkedService): Promise<AzureDataFactoryLinkedService> {
        const properties = linkedServiceResource.properties as Model.AzureDataFactoryLinkedService;

        linkedService.subscriptionId = properties.typeProperties.subscriptionId;
        linkedService.resourceGroupName = properties.typeProperties.resourceGroupName;
        linkedService.dataFactoryName = properties.typeProperties.dataFactoryName;

        switch (properties.typeProperties.authenticationType) {
            case restAuthTypes.AadServicePrincipal:
                linkedService.authenticationType = restAuthTypes.AadServicePrincipal;
                linkedService.servicePrincipalId = properties.typeProperties.servicePrincipalId;
                linkedService.tenant = properties.typeProperties.tenant;
                linkedService.servicePrincipalKey = secretBaseToPasswordOrAKV(properties.typeProperties.servicePrincipalKey, true, this.context);
                break;
            case restAuthTypes.ManagedServiceIdentity:
                linkedService.authenticationType = restAuthTypes.ManagedServiceIdentity;
                break;
            default:
                break;
        }

        return linkedService;
    }
}
